import React from 'react';
import { ScrollButtonDefaultStyle, ArrowWrapper } from '../../styles';
import getIcon from '../../../utils/getIcon';
var ArrowRight = getIcon('ArrowLargeRight');
var ArrowLeft = getIcon('ArrowLargeLeft');
var ScrollButton = function (_a) {
    var right = _a.right;
    return (React.createElement(ScrollButtonDefaultStyle, { role: "button", "data-testid": right ? 'nextArrow' : 'prevArrow' },
        React.createElement(ArrowWrapper, null, right ? React.createElement(ArrowRight, { color: "#333", size: "75%" }) : React.createElement(ArrowLeft, { color: "#333", size: "75%" }))));
};
export default ScrollButton;
//# sourceMappingURL=index.js.map